import gql from 'graphql-tag';

// query the discount codes belonging to the user
const GET_DISCOUNT_CODES = gql`
  query getDiscountCodes {
    viewer {
      discountCodes {
        edges {
          node {
            id
            code
            updatedAt
            discount {
              id
              updatedAt
              name
              value
              flat
              verticalDetails {
                sneakers {
                  value
                  flat
                  maxUses
                  upperLimit
                  minPrice
                }
                handbags {
                  value
                  flat
                  maxUses
                  upperLimit
                  minPrice
                }
                watches {
                  value
                  flat
                  maxUses
                  upperLimit
                  minPrice
                }
                collectibles {
                  value
                  flat
                  maxUses
                  upperLimit
                  minPrice
                }
                streetwear {
                  value
                  flat
                  maxUses
                  upperLimit
                  minPrice
                }
              }
              upperLimit
              minPrice
              userContext
              skus
              products
              customerUuids
            }
            customerUuid
            activatesAt
            expiresAt
            maxUsesPerUser
            maxUses
            secure
          }
        }
      }
    }
  }
`;

export default GET_DISCOUNT_CODES;
